import * as Immutable from "immutable";
export default class ParameterBinding {
  constructor(type, value) {
    this._value = { type, value };
  }
  get type() {
    return this._value.type;
  }
  get value() {
    return this._value.value;
  }
  toBuilder() {
    const { type, value } = this._value;
    return new Builder(Immutable.Map({ type, value }));
  }
  static create(type, value) {
    return new ParameterBinding(type, value);
  }
  static forValue(value) {
    return ParameterBinding.create("value", value);
  }
  static empty() {
    return ParameterBinding.create("value", "");
  }
  toJSON() {
    const { type, value } = this._value;
    return {
      type,
      value
    };
  }
  static fromJSON(json) {
    if (json == null) {
      return null;
    }
    const { type, value } = json;
    return ParameterBinding.create(type, value);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this._value = value;
  }
  type(value) {
    return new Builder(this._value.set("type", value));
  }
  value(value) {
    return new Builder(this._value.set("value", value));
  }
  build() {
    const { type, value } = this._value.toObject();
    return new ParameterBinding(type, value);
  }
}
